import { useState } from 'react';
import PageHeading from '../PageHeading/PageHeading';
import EditMainPage from '../Settings/PagesAndFiles/components/EditMainPage/EditMainPage';
import { ActionsContext } from '../../../assets/contexts/actionsContext';
import './MainPageEditor.css';

function MainPageEditor() {
    const [actions, setActions] = useState([]);

    return (
        <ActionsContext.Provider value={{ actions, setActions }}>
            <div className='main-page-editor'>
                <PageHeading
                    className={'main-page-editor__heading'}
                    title={'Редактор главной'}
                    actions={actions}
                />
                <EditMainPage />
            </div>
        </ActionsContext.Provider>
    );
}

export default MainPageEditor;
